// extracted by mini-css-extract-plugin
export var addOn = "index-module--addOn--75a46";
export var beta = "index-module--beta--f7c98";
export var feature = "index-module--feature--1da96";
export var tag = "index-module--tag--3bd1c";
export var tag_text = "index-module--tag_text--899d1";